import {
  Flex,
  Table,
  Progress,
  Icon,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
} from "@chakra-ui/react";
import React, { useMemo } from "react";
import {
  useGlobalFilter,
  usePagination,
  useSortBy,
  useTable,
} from "react-table";

// Custom components
import Card from "components/card/Card";
import Menu from "components/menu/MainMenu";

import { NavLink } from "react-router-dom";

// Assets
import { MdCheckCircle, MdCancel, MdOutlineError } from "react-icons/md";
import { Link } from "react-router-dom";
import dayjs from "dayjs";
export default function ColumnsTable(props) {
  const { columnsData, tableData, name } = props;

  const columns = useMemo(() => columnsData, [columnsData]);
  const data = useMemo(() => tableData, [tableData]);

  const tableInstance = useTable(
    {
      columns,
      data,
    },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    initialState,
  } = tableInstance;
  initialState.pageSize = 1000;

  const convertMoneyValue = (number) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(number)

  const textColor = useColorModeValue("secondaryGray.900", "white");
  const borderColor = useColorModeValue("gray.200", "whiteAlpha.100");
  return (
    <Card
      direction='column'
      w='100%'
      px='0px'
      overflowX={{ sm: "scroll", lg: "hidden" }}>
      <Flex px='25px' justify='space-between' mb='10px' align='center'>
        <Text
          color={textColor}
          fontSize='22px'
          fontWeight='700'
          lineHeight='100%'>
          Previsões {name ? `- ${name}` : ""}
        </Text>
        <Menu />
      </Flex>
      <Table {...getTableProps()} variant='simple' color='gray.500' mb='24px'>
        <Thead>
          {headerGroups.map((headerGroup, index) => (
            <Tr {...headerGroup.getHeaderGroupProps()} key={index}>
              {headerGroup.headers.map((column, index) => (
                <Th
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                  pe='10px'
                  key={index}
                  borderColor={borderColor}>
                  <Flex
                    justify='space-between'
                    align='center'
                    fontSize={{ sm: "10px", lg: "12px" }}
                    color='gray.400'>
                    {column.render("Header")}
                  </Flex>
                </Th>
              ))}
            </Tr>
          ))}
        </Thead>
        <Tbody {...getTableBodyProps()}>
          {page.map((row, index) => {
            prepareRow(row);
            return (
              <Tr {...row.getRowProps()} key={index}>
                {row.cells.map((cell, index) => {
                  console.log('row: ', row)
                  let data = "";
                  if (cell.column.Header === "NOME") {
                    data = (
                      <NavLink to="/admin/relatorio">
                        <Text color={textColor} fontSize='sm' fontWeight='700'>
                          {cell.value}
                        </Text>
                      </NavLink>
                    );
                  } else if (cell.column.Header === "STATUS") {
                    data = (
                      <Flex align='center'>
                        <Icon
                          w='24px'
                          h='24px'
                          me='5px'
                          color={
                            cell.value === "Processado"
                              ? "green.500"
                              : cell.value === "Disable"
                              ? "red.500"
                              : cell.value === "Erro"
                              ? "orange.500"
                              : null
                          }
                          as={
                            cell.value === "Processado"
                              ? MdCheckCircle
                              : cell.value === "Disable"
                              ? MdCancel
                              : cell.value === "Erro"
                              ? MdOutlineError
                              : null
                          }
                        />
                        <Text color={textColor} fontSize='sm' fontWeight='700'>
                          {cell.value}
                        </Text>
                      </Flex>
                    );
                  } else if (cell.column.Header === "DATA") {
                    data = (
                      <Text color={textColor} fontSize='sm' fontWeight='700'>
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "CONVERSOES") {
                    data = (
                      <Text color={textColor} fontSize='sm' fontWeight='700'>
                        {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "VALOR") {
                    data = (
                      <Text color={textColor} fontSize='sm' fontWeight='700'>
                        R$ {cell.value}
                      </Text>
                    );
                  } else if (cell.column.Header === "INVISTA ATÉ") {
                    data = (
                      <Text color={textColor} fontSize='sm' fontWeight='700'>
                        R$ {cell.value}
                      </Text>
                    );
                  } else if (cell.column.id === 'last_date' || cell.column.id === 'projected_max_date') {
                    data = (
                      <Text color={textColor} fontSize='sm' fontWeight='700'>
                        {dayjs(cell.value).format('DD/MM/YYYY')}
                      </Text>
                    ) // 
                  } else if (cell.column.id === 'total_cost' || cell.column.id === 'total_revenue' || cell.column.id === 'total_profit' || cell.column.id === 'cost_per_day' || cell.column.id === 'suggested_cost_per_day' || cell.column.id === 'projected_cost'  || cell.column.id === 'projected_revenue' || cell.column.id === 'projected_profit') {
                    data = (
                      <Text color={textColor} fontSize='sm' fontWeight='700'>
                        {convertMoneyValue(cell.value)}
                      </Text>
                    )
                  } else if (cell.column.id === 'optimization_tag') {
                    data = (
                      <Text color={textColor} fontSize='sm' fontWeight='700'>
                        {cell.value === 'under_performance' ? 'Otimizada' : 'Não otimizada'}
                      </Text>
                    )
                  } else {
                    data = (
                      <Text color={textColor} fontSize='sm' fontWeight='700'>
                        {cell.value}
                      </Text>
                    )
                  }
                  return (
                    <Td
                      {...cell.getCellProps()}
                      key={index}
                      fontSize={{ sm: "14px" }}
                      maxH='30px !important'
                      py='8px'
                      minW={{ sm: "150px", md: "200px", lg: "auto" }}
                      borderColor='transparent'>
                      {data}
                    </Td>
                  );
                })}
              </Tr>
            );
          })}
        </Tbody>
      </Table>
    </Card>
  );
}
